/**
 * Copyright Mántum All Rights Reserved.
 */
import Common from './common';
import Doughnut from './doughnut';
import fetcher from '../fetcher';
import useSWR from 'swr';
import { useMemo } from 'react';
import { validator } from '@mantum/kanela';

import type { DataSource } from '@mantum/kanela';
import type { Limit, Series, Overlapping } from '../type';
import type { Palette } from 'devextreme/common/charts';

type PropTypes = {
    advanced?: {
        allowCrosshair?: boolean;
        allowExporting?: boolean;
        allowLegend?: boolean;
        allowTooltip?: boolean;
        entity?: string;
        format?: 'millions';
        overlapping?: Overlapping;
        refresh?: number;
        revalidate?: boolean;
    };
    dataSource?: DataSource | unknown[];
    limit?: Limit;
    series?: Series;
    subtitle?: string;
    theme?: Palette;
    title?: string;
    type?: 'bar' | 'area' | 'line' | 'spline' | 'donut' | 'doughnut' | 'pie';
};

export default function Index(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {},
        dataSource = [],
        type,
    } = props;

    // prettier-ignore
    const {
        refresh = undefined,
        revalidate = true
    } = advanced;

    const config = {
        refreshInterval: refresh,
        revalidateOnFocus: revalidate
    };

    const query = useMemo(() => {
        return !Array.isArray(dataSource) &&
            !validator.isUndefined(dataSource.url)
            ? {
                  url: dataSource.url,
                  args: {
                      body: dataSource.parameter,
                      headers: dataSource.headers,
                      method: dataSource.method,
                      namespace: dataSource.namespace,
                      pagination: dataSource.pagination
                  }
              }
            : null;
    }, [dataSource]);

    const { data = [] } = useSWR<unknown[]>(query, fetcher, config);
    const items = !Array.isArray(dataSource) ? data : dataSource;

    if (type === 'donut' || type === 'doughnut' || type === 'pie') {
        return <Doughnut {...props} dataSource={items} type={type} />;
    }

    return <Common {...props} dataSource={items} type={type} />;
}
